import React, { useState }  from "react";
import ExpressionEditor from '../../component/ExpressionGenerator/ExpressionGenerator'
import { useGetFormulasQuery, useGetNumericVariables } from '../../queries/Formulas';
import { useChangeFormula, useCreateFormula } from '../../queries/Formulas';
import {useOktaAuth} from "@okta/okta-react";
import {
	TokenManagerInterface,
	AccessToken,
	IDToken,
	UserClaims,
} from "@okta/okta-auth-js";
import {useOktaReducer} from "../../store/okta";
import axios from "axios";
import "./style.scss";

const buildExpressionString = (expr: any, variables: any) => {
  const variable_map: any = {};
  variables.map( (v: any) => { 
    variable_map[v.value] = v.label
  });

  const toString = (node: any) => {
    if (!node || typeof node !== "object") return "";

    switch (node.type) {
      case "constant":
        return node.value.toString();

      case "variable":
        return variable_map[node.name];

      case "operation":
        const left: any = toString(node.left);
        const right: any = toString(node.right);
        return `(${left} ${node.operator} ${right})`;

      default:
        throw new Error("Unknown node type: " + node.type);
    }
  }

  return `= ${toString(expr)}`;
}

const ExpressionBuilder: React.FC<any> = ({
  data,
  refetch,
  otherData,
  selections
}) => {

  const [expression, setExpression] = useState<any>(data.formula_object);
  const [formulaName, setFormulaName] = useState<any>(data.formula_name);
  const [editMode, setEditMode] = useState<any>(false);

  const { mutate: updateFormula } = useChangeFormula(
    (data: any, variables: any, context: any) => {
      // Display a success toast?
      refetch();
    },
    (error: any, variables: any, context: any) => {
      // Display an error toast
    },
    () => {}
  );

  const expressionUpdateHandler = (e:any) => {
    updateFormula({"entries": [{
        variable_name: data.variable_name,
        formula_object: expression,
        enabled: data.enabled,
        formula_name: data.formula_name,
        new_formula_name: formulaName
      }]
    });
    setEditMode(false);
  }

  const expressionDeleteHandler = async (e:any) => {
    new Promise( async (resolve, reject) => {
      const response = await axios.delete(
        `https://api.concept.lawscore.com/api/formulas`,
          { headers: {}, data: { "entries": [{
            variable_name: data.variable_name,
            formula_object: expression,
            enabled: data.enabled,
            formula_name: data.formula_name,
            new_formula_name: formulaName
          }] } }
      );
      resolve(response.data);
      setEditMode(false);
      refetch();
    })
  }

  if(!editMode) 
    return <div style={{ marginBottom: "40px"}}>
      <div className="formula-name-equation-wrapper">
        <button style={{ backgroundColor: "green", marginRight: "25px" }} onClick={() => setEditMode(true)}>Edit Variable</button>
        <h3>{formulaName} {buildExpressionString(expression, selections)}</h3>
      </div>
    </div>

  return <div style={{ marginBottom: "40px"}}>
          <div className="formula-name-equation-wrapper">
            <input
              type="text"
              className="formula-name"
              placeholder="Formula Name"
              value={formulaName}
              onChange={(e:any) => {
                setFormulaName(e.target.value); 
              }}
              style={{ width: '20%', marginRight: "5px" }}
            /><h3>{buildExpressionString(expression, selections)}</h3>
          </div>
          <div className="formula-wrapper">
            <button style={{ backgroundColor: "green" }} onClick={expressionUpdateHandler}>Save Variable</button>
            <button style={{ backgroundColor: "red" }} onClick={expressionDeleteHandler}>Delete Variable</button>
            <button style={{ backgroundColor: "grey" }} onClick={() => setEditMode(false)}>Cancel</button>
            <ExpressionEditor node={expression} onChange={setExpression} selections={selections} />
          </div>
    </div>
}

const Settings: React.FC<any> = ({ advanced = false}: any) => {

  const {oktaAuth} = useOktaAuth();
  const authClient: any = useOktaReducer();
  const [ userInfo, setUserInfo ]: any = React.useState<any>({});

  const getInfo = async () => {
    const tokenManager: TokenManagerInterface = authClient.tokenManager;
    const accessToken: AccessToken = (await tokenManager.get(
      "accessToken"
    )) as AccessToken;
    const idToken: IDToken = (await tokenManager.get("idToken")) as IDToken;
    const userInfo: UserClaims = await authClient.token.getUserInfo(
      accessToken,
      idToken
    );

    const adminAccess = accessToken.claims.userType === 'Admin';
    const userFullName = accessToken.claims.fullName;
    setUserInfo({
      access: adminAccess,
      name: userFullName
    })
  };

  React.useEffect(() => {
    getInfo();
  }, []);
  
  const { data, isFetching, isError, refetch } = useGetFormulasQuery();

  const { data: variableData, isFetching: variableDataFetching, isError: variableError } = useGetNumericVariables();

  const [formulaName, setFormulaName] = useState<any>("");
  const { mutate: createFormula } = useCreateFormula(
    // On Success
    (data: any) => {
      // Display a success toast
      setFormulaName("");
      refetch();
    },
    // On Error
    (error: any, variables: any, context: any) => {
      // Display an error toast
      setFormulaName("");
      refetch();
    },
    () => {}
  );

  const newExpressionHandler = (e:any) => {
    createFormula({"entries": [{
        variable_name: formulaName.toLowerCase().replace(/ /g, "_"), // Replace multiple times, not once
        formula_object: {
          type: "constant",
          value: 0,
        },
        enabled: true,
        formula_name: formulaName
      }]
    });

    refetch();
  }


  if(isFetching || variableDataFetching) return <></>

  if(isError || variableError) return <>Err! Contact an administrator</>

  const formattedSelections = variableData?.map((d: any) => {
    return { 
      value: d["variable_name"],
      label: d["display_name"]
    }
  })

	return (
		<div className="home-wrapper table-layout">
			<h2>{!advanced ? "Basic" : "Advanced"} Settings</h2><br/>
      {  advanced &&
      <div className="create-formula-wrapper">
          <input
            type="text"
            className="formula-name"
            placeholder="Variable Name"
            value={formulaName}
            onChange={(e:any) => {
              setFormulaName(e.target.value); 
            }}
            style={{ width: '20%', marginRight: "5px" }}
          />
          <button style={{ "backgroundColor": "gold" }} onClick={newExpressionHandler}>Create New Variable</button>
      </div>}
			<div className="mailchimp-table-wrapper">
        {
          data?.filter( (formula:any) => formula.advanced === advanced ).map( (formula_data:any) => {
            return <ExpressionBuilder data={formula_data} refetch={refetch} otherData={data} selections={formattedSelections} />
          })
        }
			</div>
      {
        (userInfo["access"] && advanced) && <><a href={`/${advanced ? "basic" : "advanced"}-settings`}>{advanced ? "Basic" : "Advanced"} Settings</a><br/></>
      }
      {
        (userInfo["access"] && !advanced) && <><a href={`/${advanced ? "basic" : "advanced"}-settings`}>{advanced ? "Basic" : "Advanced"} Settings</a><br/></>
      }
      { userInfo["access"] && <a href="/team-settings">Team Settings</a> }
		</div>
	);
};

export default Settings;
